import React from 'react'
import { MapPOILayer } from '../map-poi-layer';
import { MapOverviewCityHotpointOverlay, MapOverviewCityIndicator } from './subcomponents';

const MapInteractiveOverlay = React.memo(({data, ready}) => {
    if (!ready) return null;

    return (
        <div>
            <MapOverviewCityIndicator/>
            <MapOverviewCityHotpointOverlay/>
            <MapPOILayer data={data} />
            <style jsx>{`   
                div {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    z-index: 0;
                    height: 100%;
                }
            `}</style>
        </div>
    )
});



export default MapInteractiveOverlay